import { defineComponent, ref, computed, toRef, resolveComponent, openBlock, createElementBlock, normalizeClass, createElementVNode, withModifiers, createVNode, renderSlot, toDisplayString, withDirectives, vShow, Fragment, createCommentVNode, createTextVNode } from 'vue';
import { t as te } from '../OrAutocompleteV3-8c6de221.js';
import { OrIconV3 as script$1 } from '../or-icon-v3/index.js';
import '@vueuse/core';
import '@onereach/styles/screens.json';
import '@onereach/styles/tailwind.config.json';
import 'lodash/get';
import 'lodash/isElement';
import '../or-error-v3/index.js';
import '../or-hint-v3/index.js';
import '../or-icon-button-v3/index.js';
import '../or-tooltip-v3/index.js';
import '../or-popover-v3/index.js';
import '@floating-ui/dom';
import '../or-bottom-sheet-v3/index.js';
import '../or-overlay-v3/index.js';
import '../or-teleport-v3/index.js';
import '../or-input-box-v3/index.js';
import '../or-input-v3/index.js';
import '../OrInlineInputV3-061441a3.js';
import '../or-inline-input-box-v3/index.js';
import '../or-text-v3/index.js';
import '../or-label-v3/index.js';
import '../or-loader-v3/index.js';
import '../or-menu-item-v3/index.js';
import '../or-tag-input-v3/index.js';
import '../or-tags-v3/index.js';
import '../or-button-v3/index.js';
import '../or-tag-v3/index.js';

var ExpansionPanelVariant;
(function (ExpansionPanelVariant) {
  ExpansionPanelVariant["Default"] = "default";
  ExpansionPanelVariant["Card"] = "card";
})(ExpansionPanelVariant || (ExpansionPanelVariant = {}));
var ExpansionPanelColor;
(function (ExpansionPanelColor) {
  ExpansionPanelColor["Default"] = "default";
  ExpansionPanelColor["Danger"] = "danger";
})(ExpansionPanelColor || (ExpansionPanelColor = {}));
var ExpansionPanelBackgroundColor;
(function (ExpansionPanelBackgroundColor) {
  ExpansionPanelBackgroundColor["Primary"] = "primary";
  ExpansionPanelBackgroundColor["Secondary"] = "secondary";
  ExpansionPanelBackgroundColor["Inherit"] = "inherit";
})(ExpansionPanelBackgroundColor || (ExpansionPanelBackgroundColor = {}));

const ExpansionPanel = [
// Layout
'layout-column'];
const ExpansionPanelDescription = [
// Typography
'typography-caption-regular'];
const ExpansionPanelDescriptionDisabled = [
// Theme
'theme-foreground-disabled', 'dark:theme-foreground-disabled-dark'];
const ExpansionPanelVariants = {
  [ExpansionPanelVariant.Default]: [
  // Spacing
  'gap-md'],
  [ExpansionPanelVariant.Card]: [
  // Shape
  'rounded-md',
  // Spacing
  'px-md', 'py-md', 'gap-md']
};
const ExpansionPanelBackgroundColors = {
  'primary-default': [],
  'primary-card': [
  // Theme
  'theme-background-surface-1', 'dark:theme-background-surface-1-dark'],
  'secondary-default': [],
  'secondary-card': [
  // Theme
  'theme-background-surface-3', 'dark:theme-background-surface-3-dark'],
  'inherit-default': [],
  'inherit-card': [
  // Theme
  'theme-background-inherit', 'dark:theme-background-inherit']
};
const ExpansionPanelHeader = [
// Layout
'layout-row',
// Interactivity
'interactivity-click',
// Box
'min-w-[16px]',
// Spacing
'gap-sm',
// Typography
'typography-body-2-bold',
// Theme
'outline-none'];
const ExpansionPanelHeaderColors = {
  'default': [
  // Theme
  'theme-foreground-default', 'dark:theme-foreground-default-dark',
  // Theme (hover)
  'hover:theme-foreground-primary', 'dark:hover:theme-foreground-primary-dark',
  // Theme (focus)
  'focus-visible:theme-foreground-primary', 'dark:focus-visible:theme-foreground-primary-dark',
  // Theme (active)
  'active:theme-foreground-primary', 'dark:active:theme-foreground-primary-dark'],
  'danger': [
  // Theme
  'theme-foreground-error', 'dark:theme-foreground-error-dark',
  // Theme (hover)
  'hover:theme-foreground-error-hover', 'dark:hover:theme-foreground-error-hover-dark',
  // Theme (focus)
  'focus-visible:theme-foreground-error-hover', 'dark:focus-visible:theme-foreground-error-hover-dark',
  // Theme (active)
  'active:theme-foreground-error-hover', 'dark:active:theme-foreground-error-hover-dark']
};
const ExpansionPanelAddon = [
// Layout
'contents',
// Typography
'typography-body-2-regular',
// Theme
'theme-foreground-outline', 'dark:theme-foreground-outline-dark'];
const ExpansionPanelContentLeftIndent = [
// Spacing
'ml-[28px] md:ml-[24px]'];

var script = defineComponent({
  name: 'OrExpansionPanel',
  components: {
    OrIcon: script$1
  },
  props: {
    label: {
      type: String,
      default: undefined
    },
    isOpen: {
      type: Boolean,
      default: false
    },
    description: {
      type: String,
      default: undefined
    },
    variant: {
      type: String,
      default: () => ExpansionPanelVariant.Default
    },
    color: {
      type: String,
      default: () => ExpansionPanelColor.Default
    },
    backgroundColor: {
      type: String,
      default: () => ExpansionPanelBackgroundColor.Primary
    },
    leftIndent: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    keepAlive: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:state', 'open', 'close'],
  expose: ['root', 'state', 'open', 'close', 'toggle'],
  setup(props, context) {
    // Refs
    const root = ref();
    // Styles
    const rootStyles = computed(() => ['or-expansion-panel-v3', ...ExpansionPanel, ...ExpansionPanelVariants[props.variant], ...ExpansionPanelBackgroundColors[`${props.backgroundColor}-${props.variant}`]]);
    const headerStyles = computed(() => [...ExpansionPanelHeader, ...ExpansionPanelHeaderColors[props.color]]);
    const addonStyles = computed(() => [...ExpansionPanelAddon]);
    const contentStyles = computed(() => [props.leftIndent ? ExpansionPanelContentLeftIndent : '']);
    const descriptionStyles = computed(() => [...ExpansionPanelDescription, props.disabled ? ExpansionPanelDescriptionDisabled : '']);
    // State
    const {
      state,
      open,
      close,
      toggle
    } = te(toRef(props, 'isOpen'), context.emit);
    return {
      root,
      rootStyles,
      headerStyles,
      addonStyles,
      contentStyles,
      descriptionStyles,
      state,
      open,
      close,
      toggle
    };
  }
});

const _hoisted_1 = ["disabled"];
const _hoisted_2 = {
  class: /*#__PURE__*/normalizeClass(['layout-row', 'justify-between'])
};
const _hoisted_3 = ["tabindex", "disabled"];
const _hoisted_4 = {
  class: "truncate"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrIcon = resolveComponent("OrIcon");
  return openBlock(), createElementBlock("div", {
    ref: 'root',
    class: normalizeClass(_ctx.rootStyles),
    disabled: _ctx.disabled
  }, [createElementVNode("div", _hoisted_2, [createElementVNode("div", {
    class: normalizeClass(_ctx.headerStyles),
    tabindex: !_ctx.disabled ? 0 : null,
    disabled: _ctx.disabled,
    onClick: _cache[0] || (_cache[0] = withModifiers($event => _ctx.toggle(), ["stop"]))
  }, [createVNode(_component_OrIcon, {
    class: normalizeClass([_ctx.state === 'open' ? 'rotate-0' : 'rotate-[-90deg]']),
    icon: 'expand_more',
    variant: 'filled-bold'
  }, null, 8 /* PROPS */, ["class"]), renderSlot(_ctx.$slots, "label", {
    state: _ctx.state
  }, () => [createElementVNode("span", _hoisted_4, toDisplayString(_ctx.label), 1 /* TEXT */)])], 10 /* CLASS, PROPS */, _hoisted_3), createElementVNode("div", {
    class: normalizeClass(_ctx.addonStyles)
  }, [renderSlot(_ctx.$slots, "addon")], 2 /* CLASS */)]), _ctx.keepAlive ? withDirectives((openBlock(), createElementBlock("div", {
    key: 0,
    class: normalizeClass(_ctx.contentStyles)
  }, [renderSlot(_ctx.$slots, "default")], 2 /* CLASS */)), [[vShow, _ctx.state === 'open']]) : (openBlock(), createElementBlock(Fragment, {
    key: 1
  }, [_ctx.state === 'open' ? (openBlock(), createElementBlock("div", {
    key: 0,
    class: normalizeClass(_ctx.contentStyles)
  }, [renderSlot(_ctx.$slots, "default")], 2 /* CLASS */)) : createCommentVNode("v-if", true)], 64 /* STABLE_FRAGMENT */)), (_ctx.description || _ctx.$slots.description) && _ctx.state != 'open' ? (openBlock(), createElementBlock("div", {
    key: 2,
    class: normalizeClass(_ctx.descriptionStyles)
  }, [renderSlot(_ctx.$slots, "description", {}, () => [createTextVNode(toDisplayString(_ctx.description), 1 /* TEXT */)])], 2 /* CLASS */)) : createCommentVNode("v-if", true)], 10 /* CLASS, PROPS */, _hoisted_1);
}

script.render = render;
script.__file = "src/components/or-expansion-panel-v3/OrExpansionPanel.vue";

export { ExpansionPanelBackgroundColor, ExpansionPanelColor, ExpansionPanelVariant, script as OrExpansionPanelV3 };
